import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import {
  DeleteAPICall,
  axiosDTVbasicAuthForm,
  axiosapibaseurl,
  postAPICall,
  s3url,
  setToastRef,
  showErrorToast,
  showSuccessToast,
  showToast,
} from "../Api/Api";
import { DataTable } from "primereact/datatable";
import { ProgressSpinner } from "primereact/progressspinner";
import { Column } from "primereact/column";
import "./Style.css"; // Import your custom CSS file
import axios from "axios";
import { Toast } from "primereact/toast";
import { MdDelete } from "react-icons/md";
import { FaVideo } from "react-icons/fa6";
import { RiVideoUploadFill } from "react-icons/ri";
import { InputText } from "primereact/inputtext";
import GlobalPopup from "../GlobalComponents/GlobalPopup.jsx";
import { useLoader } from "../GlobalComponents/Loader.jsx";
export default function LibraryGrid(props) {
  const [LibraryGridData, setLibraryGridData] = useState([]);
        const { showLoader, hideLoader } = useLoader();
  
  const [showDialog, setShowDialog] = useState(false);
  const [selectedVideoSrc, setSelectedVideoSrc] = useState("");
  const [location, SetVideoPath] = useState("");
  const [MediaLocation, setMediaLocation] = useState("");
  const [Files, setFiles] = useState(false);
  const fileInputRef = useRef(null);
  const toast = useRef(null);
  const [LibraryDeletedData, setLibraryDeletedData] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedrowvalue, setSelectedrowvalue] = useState("");

  useEffect(() => {
    setToastRef(toast.current);
    if (props.selectednewid !== "") {
      fetchLibraryGridData();
    }
  }, [props, props.selectednewid]);

  const fetchLibraryGridData = async () => {
    showLoader()
    let TreeCategoryID = props?.selectednewid.toString() || "";
    if (props.selectedNodeKeyLevel == "1") {
      const requestBody = {
        AccountGroupCode: localStorage.getItem("AccountGroupCode"),
      };
      try {
        const response = await postAPICall(
          "api/Library/GetAccountGroupMediaList",
          requestBody
        );
        if (response?.status === 200) {
          setLoading(false);
          hideLoader();
          setLibraryGridData(response?.data || []);
        } else {
          hideLoader();
          setLibraryGridData([]);
        }
      } catch (error) {
        hideLoader()
        showErrorToast("Error fetching library data:");
      }
    } else {
      const requestBody = {
        categoryId: TreeCategoryID,
      };
      try {
        const response = await postAPICall(
          "api/Library/GetLibraryData",
          requestBody
        );
        if (response?.status === 200) {
          hideLoader()
          setLoading(false);
          setLibraryGridData(response?.data || []);
        } else {
          hideLoader()
          setLibraryGridData([]);
        }
      } catch (error) {
        showErrorToast("Error fetching library data:");
      }
    }
    hideLoader();
  };
  //Play video event
  // const handlePreviewClick = (rowData) => {
  //   debugger
  //   setSelectedVideoSrc(rowData.MediaLocation);
  //   if (rowData !== undefined) {
  //     const Videolocation = s3url + rowData.MediaLocation;
  //     SetVideoPath(Videolocation);
  //     setShowDialog(true);
  //     setTimeout(() => {
  //       const videoElement = document.getElementById("videoplay");
  //       if (videoElement) {
  //         videoElement?.play();
  //       }
  //     }, 500);
  //   }
  // };
  const handlePreviewClick = (rowData) => {
    if (rowData !== undefined) {
      // Set the video source URL
      setSelectedVideoSrc(rowData.MediaLocation);

      // Construct the full video URL
      const videoLocation = s3url + rowData.MediaLocation;
      SetVideoPath(videoLocation);

      // Show the dialog for video preview
      setShowDialog(true);

      // Ensure the video element is properly loaded and ready
      const videoElement = document.getElementById("videoplay");

      if (videoElement) {
        videoElement.src = videoLocation; // Set video source
        videoElement.load(); // Ensure the video is reloaded before playing

        // Play the video after it has loaded
        videoElement.oncanplay = () => {
          videoElement.play().catch((error) => {
            console.error("Error playing video:", error);
          });
        };
      }
    }
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };
  //set play icon all row
  const previewIconTemplate = (rowData) => {
    return (
      <Button
        id="playicon"
        icon={<FaVideo />}
        className="p-button p-button-text"
        onClick={() => handlePreviewClick(rowData)}
      ></Button>
    );
  };
  //Row Selection event
  const HandleRowSelect = (e) => {
    setSelectedrowvalue(e.value);
    setMediaLocation(e.value.MediaLocation);
  };
  //Kess press Event
  // const HandleKeyDown = (e) => {
  //   debugger
  //   if (e.code === "Enter") {
  //     const Videolocation = s3url + MediaLocation;
  //     SetVideoPath(Videolocation);
  //     setShowDialog(true);
  //     setTimeout(() => {
  //       const videoElement = document.getElementById("videoplay");
  //       if (videoElement) {
  //         videoElement?.play();
  //       }
  //     }, 500); // Adjust delay as needed
  //   } else if (e.code === "Escape") {
  //     setShowDialog(false);
  //   }
  // };
  const HandleKeyDown = (e) => {
    if (e.code === "Enter") {
      const Videolocation = s3url + MediaLocation;
      SetVideoPath(Videolocation);
      setShowDialog(true);

      setTimeout(() => {
        const videoElement = document.getElementById("videoplay");

        // Ensure the video element is still present and ready
        if (videoElement && videoElement.readyState >= 3) {
          videoElement.play().catch((error) => {
            console.error("Error playing video: ", error);
          });
        } else {
          console.error("Video element is not ready to play.");
        }
      }, 500); // Adjust delay as needed
    } else if (e.code === "Escape") {
      setShowDialog(false);
    }
  };

  //File Uplade get File and APi call
  // const handleUpload = async (e) => {
  //   if (props?.selectednewid) {
  //     showToast("success", "Upload Started Please Wait ...");
  //     if (props?.selectednewid !== "" && e.target.files.length > 0) {
  //       setFiles(e.target.files);
  //       const formData = new FormData();
  //       for (let i = 0; i < e.target.files.length; i++) {
  //         formData.append("file", e.target.files[i]);
  //         if (i === 0) {
  //           formData.append("CategoryID", props?.selectednewid);
  //           formData.append(
  //             "AccountGroupCode",
  //             localStorage.getItem("AccountGroupCode")
  //           );
  //         }
  //       }
  //       try {
  //         let endpointURL = "api/Library/PostLibraryDataFiles";
  //         const response = await axios.post(
  //           `${axiosapibaseurl}${endpointURL}`,
  //           formData,
  //           axiosDTVbasicAuthForm
  //         );
  //         showToast("success", response.data);
  //         setFiles(false);
  //         // Reset the input field value
  //         if (fileInputRef.current) {
  //           fileInputRef.current.value = "";
  //         }
  //         fetchLibraryGridData();
  //       } catch (error) {
  //         console.error("Error uploading files:", error);
  //         showToast("error", "Error uploading files...");
  //         setFiles(false);
  //       }
  //     } else {
  //       showToast("warning", "Please Select the file and Category ID");
  //     }
  //   } else {
  //     showToast("error", "Please Select Library");
  //   }
  // };
  const handleUpload = async (e) => { 
    localStorage.setItem("Value", "true");
    if (props?.selectednewid) {
      showSuccessToast("Upload Started. Please wait ...");
      if (props?.selectednewid !== "" && e.target.files.length > 0) {
        const filesArray = e.target.files;
        const newFiles = Array.from(filesArray).map((file) => file.name);
        props?.setUploadingFiles((prev) => [...prev, ...newFiles]);
        const formData = new FormData();
        formData.append("CategoryID", props?.selectednewid);
        formData.append(
          "AccountGroupCode",
          localStorage.getItem("AccountGroupCode")
        );
        // Loop through each file and upload them sequentially
        for (let i = 0; i < filesArray.length; i++) {
          const file = filesArray[i];
          formData.append("file", file);

          try {
            let endpointURL = "api/Library/PostLibraryDataFiles";
            const response = await axios.post(
              `${axiosapibaseurl}${endpointURL}`,
              formData,
              axiosDTVbasicAuthForm
            );

            if (response.status === 200) {
              props?.setUploadingFiles((prev) =>
                prev.filter((f) => f !== file.name)

              );
              showSuccessToast(response?.Message);
            } else {
              showErrorToast(`Failed to upload file ${i + 1}: ${file.name}`);
              break; // Stop if any file fails
            }

            // Reset formData for the next file
            formData.delete("file");
          } catch (error) {
            console.error(`Error uploading file ${i + 1}:`, error);
            showErrorToast(`Error uploading file ${i + 1}: ${file.name}`);
            break; // Stop further uploads if an error occurs
          }
        }
      
      
        // Reset input after all uploads
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        fetchLibraryGridData(); // Fetch data once all uploads are done
      } else {
        showErrorToast("Please Select the file and Category ID");
      }
    } else {
      showErrorToast("Please Select Library");
    }
  };

  //Library Media delete API call
  const handleDelete = () => {
    setDeleteConfirmation(true);
  };
  const confirmDelete = async () => { 
    const requestBody = {
      mediaID: LibraryDeletedData.MediaID,
    };
    const response = await DeleteAPICall(
      "api/Library/DeleteLibraryMedia",
      requestBody
    );
    fetchLibraryGridData(); 
    showSuccessToast("Deleted...");
    setDeleteConfirmation(false);
  };
  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          id="LibraryGridDeleteIcon"
          icon={<MdDelete />}
          className="p-button-rounded p-button-primary"
          onClick={() => {
            setLibraryDeletedData(rowData);
            handleDelete();
          }}
        />
      </div>
    );
  };

  const filteredData = LibraryGridData.filter((LibraryGridData) =>
    LibraryGridData.MediaName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const LibrarryVideoPreview = (
    <div>
      <video id="videoplay" controls tabIndex="0">
        <source src={location} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
  const LibraryGridDeleteConfirmation = (
    <div>
      <Button
        style={{ borderRadius: "5px", padding: "15px" }}
        label="Yes"
        icon="pi pi-check"
        onClick={confirmDelete}
        autoFocus
      />
      <Button
        style={{
          borderRadius: "5px",
          padding: "15px",
          backgroundColor: "lightslategray",
          color: "white",
        }}
        label="No"
        icon="pi pi-times"
        onClick={() => setDeleteConfirmation(false)}
        className="p-button-text"
      />
    </div>
  );
  return (
    <div className="library-grid-container">
      {" "}
      {/* Apply CSS class for styling */}
      <Toast ref={toast} />
      <div id="MediamasterHeaderCard">
        <div style={{ marginTop: "5px" }}>
          <b id="SelectedName">{props.selectednewname}</b>
        </div>
        {/* {props.selectednewid && ( */}
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <InputText
            id="LibraryGridSeacrh"
            type="search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search..."
          />
          <Button
            icon="pi pi-search"
            style={{
              backgroundColor: "lightslategray",
              border: "lightslategray",
            }}
            id="LibraryGridSeacrhICon"
            className="p-button-primary"
            title="Search"
          />

          <div style={{ display: "flex", marginLeft: "auto" }}>
            <b hidden={Files ? false : true} style={{}} id="UploadTxt">
              Uploading...
            </b>
            <form title="Upload">
              <label>
                <div>
                  <input
                    disabled={!props.selectednewid}
                    ref={fileInputRef}
                    id="choose file"
                    hidden
                    accept="video/mp4"
                    type="file"
                    multiple
                    onChange={handleUpload}
                  />
                  <label
                    htmlFor="choose file"
                    style={{
                      cursor: "pointer",
                      color: props.selectednewid ? "inherit" : "lightslategray",
                    }}
                  >
                    <i id="uploadIcon" className="fa">
                      <RiVideoUploadFill />
                    </i>
                  </label>
                </div>
              </label>
            </form>
          </div>
        </div>
        {/* )} */}
      </div>
      {loading && props.selectednewid ? (
        <ProgressSpinner
          style={{ width: "50px", height: "30px", marginTop: "250px" }}
          strokeWidth="3"
        />
      ) : (
        <DataTable
          value={filteredData}
          className="p-datatable"
          scrollable
          scrollHeight="90vh"
          selectionMode={"single"}
          onSelectionChange={HandleRowSelect}
          onKeyDown={HandleKeyDown}
          rowClassName={(rowData) =>
            selectedrowvalue && selectedrowvalue.MediaID === rowData.MediaID
              ? "selected-row"
              : ""
          }
        >
          <Column
            field="MediaName"
            header="MediaName"
            align="center"
            body={(rowData) => {
              return <span title={rowData.MediaName}>{rowData.MediaName}</span>;
            }}
          />
          <Column field="MediaDuration" header="MediaDuration" sortable />
          <Column
            field="MediaLocation"
            header="MediaLocation"
            sortable
            hidden
          />
          <Column field="MediaSizeMB" header="MediaSizeMB" sortable />
          <Column header="Delete" body={actionTemplate} />
          <Column
            header="Preview"
            width={100}
            allowFiltering={false}
            allowSorting={false}
            body={previewIconTemplate}
          />
          <Column
            field="name"
            header="Name"
            hidden={props?.selectedNodeKeyLevel === "1" ? false : true}
          />
        </DataTable>
      )}
      <GlobalPopup
        title={"Video Preview"}
        visible={showDialog}
        onHide={handleCloseDialog}
        footerButtons={LibrarryVideoPreview}
        Popupwidth={800}
        Popupheight={500}
      />
      <GlobalPopup
        title="Confirmation"
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={LibraryGridDeleteConfirmation}
        content={
          <div className="confirmation-content">
            <i
            // className="pi pi-exclamation-triangle p-mr-3"
            // style={{ fontSize: "4rem", color: "var(--warning-color)" }}
            />
            <br />
            <h6>Are you sure you want to delete this Library Data?</h6>
          </div>
        }
      />
    </div>
  );
}
